import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

export function getBettingCenterConfig() {
    return {
        palette: {
            [PALETTE_IDS.BET_RECEIPT]: {
                BET_RECEIPT_BET_HEADER_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
            },
            [PALETTE_IDS.BETTING_CENTER]: {
                BETTING_CENTER_TAB_BUTTON_BG: COLOR.BRAND.BACKGROUND5,
                BETTING_CENTER_TAB_BUTTON_TEXT: `${COLOR.BRAND.BACKGROUND1}|${COLOR.BRAND.FOREGROUND1}`,

                BETTING_CENTER_BET_CONTAINER_BG: COLOR.BRAND.FOREGROUND4,
            },
            [PALETTE_IDS.BETSLIP]: {
                BETSLIP_REMOVE_ALL_BUTTON: {
                    TERTIARY_BUTTON_TEXT: COLOR.BRAND.FOREGROUND2,
                },

                BETSLIP_REMOVE_BET_BUTTON: {
                    CLOSE_BUTTON_ICON_COLOR: COLOR.BRAND.FOREGROUND2,
                },
                BETSLIP_BB_BET_ICON_COLOR: COLOR.BRAND.ACCENT2,

                BETSLIP_FREE_BETS_HEADER_TEXT: COLOR.BRAND.FOREGROUND2,
                // Sliding betslip
                BETSLIP_PILL_HIGHLIGHTED_BG: COLOR.BRAND.CTA2,
                BETSLIP_PILL_HIGHLIGHTED_TEXT: COLOR.BRAND.FOREGROUND4,
                BETSLIP_ODDS_BOOST_BANNER: {
                    ODDS_BOOSTS_BB_CONTAINER_BG: COLOR.BRAND.FOREGROUND4,
                },
            },
            [PALETTE_IDS.NUMERIC_KEYPAD]: {
                KEYPAD_INCREASE_BUTTON_BG: COLOR.BRAND.BACKGROUND5,
                KEYPAD_BUTTON: {
                    TOGGLE_BUTTON_BORDER_COLOR: COLOR.BRAND.BACKGROUND2,
                },
                KEYPAD_COMPACT_BUTTON: {
                    TOGGLE_BUTTON_BORDER_COLOR: COLOR.BRAND.BACKGROUND2,
                },
            },
            [PALETTE_IDS.YOUR_BET]: {
                YOUR_BET_CONTAINER_BG: COLOR.BRAND.FOREGROUND4,

                YOUR_BET_LIVE_EVENT_TIMING_STATUS: {
                    EVENT_TIMING_LIVE_TEXT: COLOR.BRAND.FOREGROUND1,
                },
                YOUR_BET_LIVE_EVENT_DATA_SEPARATOR: COLOR.BRAND.FOREGROUND1,
                YOUR_BET_LIVE_EVENT_SCOREBOARD: {
                    MINI_SCOREBOARD_SCORES_TEXT: {
                        fontSize: FONT.SIZE_SMALL,
                        color: COLOR.BRAND.ACCENT2,
                    },
                    MINI_SCOREBOARD_SCORE_COUNT_TEXT: {
                        fontSize: FONT.SIZE_SMALL,
                        color: COLOR.BRAND.ACCENT2,
                    },
                },
                YOUR_BET_RESULT_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
            },
            [PALETTE_IDS.OVERASK]: {
                OVERASK_REVIEWING_TEXT: COLOR.BRAND.FOREGROUND2,
                OVERASK_BET_OFFER_BG: COLOR.BRAND.FOREGROUND4,
                OVERASK_BET_OFFER_STATUS_TITLE_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontSize: FONT.SIZE_LARGE,
                },
                OVERASK_TRADER_BET_OFFER_CONTAINER_BG: COLOR.BRAND.BACKGROUND2,
            },
        },
    };
}
